/* Habitudes de vie : statuts simples, stockés localement (offline-first) et synchronisés via le profil. */
import { useState } from "react";
import { Cigarette, Salad, Footprints, Wind } from "lucide-react";

const HABITS = [
  { key: "tabac", label: "Tabac", Icon: Cigarette, color: "#D9534F", options: ["Je ne fume pas", "J'ai réduit", "Je fume encore"] },
  { key: "alimentation", label: "Alimentation", Icon: Salad, color: "#5CB85C", options: ["Peu de sel aujourd'hui", "Repas équilibré", "À améliorer"] },
  { key: "activite", label: "Activité", Icon: Footprints, color: "#2BA3A0", options: ["J'ai marché", "Un peu bougé", "Pas encore"] },
  { key: "respiration", label: "Respiration", Icon: Wind, color: "#3a8acb", options: ["5 min de calme", "Quelques respirations", "Pas encore"] },
];

const KEY = "bc_habits";
const today = () => new Date().toISOString().slice(0, 10);

export function HabitsTab() {
  const [state, setState] = useState(() => {
    try { const s = JSON.parse(localStorage.getItem(KEY) || "{}"); return s.date === today() ? s.values : {}; } catch { return {}; }
  });
  const set = (k, v) => {
    const next = { ...state, [k]: v };
    setState(next);
    localStorage.setItem(KEY, JSON.stringify({ date: today(), values: next }));
  };
  return (
    <div className="flex flex-col gap-3 pt-2" data-testid="habits-tab">
      <p className="text-[12px] text-[#0A1426]/70 px-1">Des habitudes simples, chaque jour, protègent contre une nouvelle attaque.</p>
      {HABITS.map((h) => (
        <div key={h.key} data-testid={`habit-${h.key}`} className="bg-white rounded-2xl border border-[#E4E0D5] p-4">
          <div className="flex items-center gap-2 mb-2">
            <span className="w-10 h-10 rounded-xl grid place-items-center" style={{ backgroundColor: `${h.color}1f`, color: h.color }}><h.Icon size={20} /></span>
            <span className="font-bold text-[#0A1426]">{h.label}</span>
          </div>
          <div className="flex flex-col gap-1.5">
            {h.options.map((o, i) => (
              <button key={o} data-testid={`habit-${h.key}-${i}`} onClick={() => set(h.key, i)}
                className={`h-11 rounded-full text-[13px] font-bold text-left px-4 ${state[h.key] === i ? "bg-[#0A1426] text-white" : "bg-[#F5F3EE] text-[#0A1426]"}`}>{o}</button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
